<template>
    <div>
        <div v-if="devcInspectInfo != null && devcInspectInfo.id != null">
            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>检验信息</span>
                </div>
            </div>
            <div class="column-layout flex">
                <div class="form-info clearfix">
                    <div class="form-row col col-6 fl">
                        <div class="form-label" style="width: 155px;">
                            <label>是否需要送出</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.objectSentOutFlag ? "是" : "否"}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label" style="width: 155px;">
                            <label>妨碍正常生产</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.interfereProdFlag ? "是" : "否"}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl" v-if="devcInspectInfo.interfereProdFlag">
                        <div class="form-label" style="width: 155px;">
                            <label>妨碍正常生产开始动作</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.interfereStartAction}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl" v-if="devcInspectInfo.interfereProdFlag">
                        <div class="form-label" style="width: 155px;">
                            <label>恢复正常生产结束动作</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.interfereEndAction}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label" style="width: 155px;">
                            <label>是否需要整改</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.rectifyOnFailFlag ? "是" : "否"}}</span>
                        </div>
                    </div>
                    <div class="form-row col col-6 fl">
                        <div class="form-label" style="width: 155px;">
                            <label>计划交接数量</label>
                        </div>
                        <div class="form-value">
                            <span>{{devcInspectInfo.planTotal}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="devcInspectInfo.handoverOutTime != null"><!-- (零售商)交接出去时间 -->
                <div class="content-caption bg-white dashed">
                    <div class="fl">
                        <span>服务方信息</span>
                    </div>
                </div>
                <div class="column-layout flex">
                    <div class="form-info clearfix">
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>接收人</label>
                            </div>
                            <div class="form-value">
                                <span>{{devcInspectInfo.handoverOutRcvName}}</span>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>接收人签名</label>
                            </div>
                            <div class="form-value">
                                <img style="width: 60px;height: 60px" :src="devcInspectInfo.handoverOutRcvSigUrl" @click="showBigImg(devcInspectInfo.handoverOutRcvSigUrl)"/>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接时间</label>
                            </div>
                            <div class="form-value">
                                <span>{{devcInspectInfo.handoverOutTime}}</span>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接总数量</label>
                            </div>
                            <div class="form-value">
                                <span>{{devcInspectInfo.handoverOutTotal}}</span>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接说明</label>
                            </div>
                            <div class="form-value">
                                <span>{{devcInspectInfo.handoverOutDesc || '无'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="devcInspectInfo.inspectDate != null"><!-- 检验日期（登记实际日期，检验结束更新到设备中） -->
                <div class="content-caption bg-white dashed">
                    <div class="fl">
                        <span>检验结果信息</span>
                    </div>
                </div>
                <div class="column-layout flex">
                    <div class="form-info clearfix">
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>检验结果状态</label>
                            </div>
                            <div class="form-value">
                                <label v-if="devcInspectInfo.inspectResult == 0">未检验</label>
                                <label class="font-green mr20" v-if="devcInspectInfo.inspectResult == 1">检验通过</label>
                                <label class="font-red mr20" v-if="devcInspectInfo.inspectResult == -1">检验不通过</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>检验次数</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.inspectTimes || 0}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>是否最终检验</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.inspectOver ? "是" : "否"}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>检验日期</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.inspectDate}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>检验结果说明</label>
                            </div>
                            <div class="form-value">
                                <label class="">{{devcInspectInfo.inspectResultDesc || '无'}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>整改状态</label>
                            </div>
                            <div class="form-value">
                                <label v-if="devcInspectInfo.rectifyState == 0">无需整改</label>
                                <label class="font-red mr20" v-if="devcInspectInfo.rectifyState == 1">整改中</label>
                                <label class="font-green mr20" v-if="devcInspectInfo.rectifyState == 2">整改结束</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>整改截止日期</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.rectifyLimitDate}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>整改说明</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.rectifyDesc || '无'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="devcInspectInfo.handoverInTime != null"><!-- 交接回来时间 -->
                <div class="content-caption bg-white dashed">
                    <div class="fl">
                        <span>被服务方信息</span>
                    </div>
                </div>
                <div class="column-layout flex">
                    <div class="form-info clearfix">
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>接收人</label>
                            </div>
                            <div class="form-value">
                                <span>{{devcInspectInfo.handoverInRcvName}}</span>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>接收人签名</label>
                            </div>
                            <div class="form-value">
                                <img style="width: 60px;height: 60px" :src="devcInspectInfo.handoverInRcvSigUrl" @click="showBigImg(devcInspectInfo.handoverInRcvSigUrl)"/>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接时间</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.handoverInTime}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接总数量</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.handoverInTotal}}</label>
                            </div>
                        </div>
                        <div class="form-row col col-6 fl">
                            <div class="form-label">
                                <label>交接说明</label>
                            </div>
                            <div class="form-value">
                                <label>{{devcInspectInfo.handoverInDesc || '无'}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="content-caption bg-white dashed">
                <div class="fl">
                    <span>设备检验分项</span>
                </div>
            </div>
            <div class="wh100">
                <div class="orders-list-container">
                    <el-table :data="devcInspectItemList" border style="width: 100%" class="mt30">
                        <el-table-column prop="shopName" label="零售机构" align="left"></el-table-column>
                        <el-table-column prop="devcTitle" label="设备名称" width="200" align="left"></el-table-column>
                        <el-table-column prop="devcNo" label="系统编号" width="220" align="left"></el-table-column>
                        <el-table-column v-if="devcInspectInfo.objectSentOutFlag" prop="planQuantity" label="计划数量" width="100" align="right"></el-table-column>
                        <!-- 交接出去数量 -->
                        <el-table-column v-if="devcInspectInfo.objectSentOutFlag" prop="quantity" label="交回数量" width="100" align="right"></el-table-column>
                        <el-table-column v-if="devcInspectInfo.objectSentOutFlag" prop="quantity2" label="交出数量" width="100" align="right"></el-table-column>
                        <el-table-column prop="inspectDate" label="检验日期" width="140" align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div class="font14 align-center font-gray2" style="margin-top: 100px;" v-else>无设备检验信息...</div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv'

    export default {
        name: 'swb-devc-inspect-info',
        avlActions: '',
        avlScopes: 'servicer',
        desc: '设备检验信息-详情',
        props: ['workVoucherId'],
        data: function () {
            return {
                devcInspectInfo: {},
                devcInspectItemList: [],
            }
        },
        created: function () {
            if(!Utils.isNoB(this.workVoucherId)) {
                this.getDevcInspectInfo();
            }
        },
        methods: {
            getDevcInspectInfo: function () {
                let self = this;
                let params = {
                    id: self.workVoucherId
                };
                servcDelivApi.getDevcInspectInfo(params, function (result) {
                    if(result.type === "info") {
                        let devcInspectInfo = result.data;
                        //
                        if(devcInspectInfo != null) {
                            self.devcInspectItemList = devcInspectInfo.itemList || [];
                            self.devcInspectInfo = devcInspectInfo;
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showBigImg: function (url) {
                Utils.setPageUrl(url, '_blank');
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/DevcInspectInfo.vue